/* -------------------------------------------------------------------------- */
/*                                  Constants                                 */
/* -------------------------------------------------------------------------- */
import packageJson from '../../../package.json';

export const API_URL = import.meta.env.VITE_API_URL;
export const BUILD_SHA = import.meta.env.VITE_BUILD_SHA;
export const VERSION = packageJson.version;

export const IS_LOCAL = import.meta.env.DEV;

export const IS_STAGING =
	import.meta.env.VITE_ENV === 'staging';

export const IS_PRODUCTION =
	import.meta.env.VITE_ENV === 'production';

export const IS_DEVELOP =
	import.meta.env.VITE_ENV === 'develop';

export const IS_DEMO =
	import.meta.env.VITE_ENV === 'demo';

export const ENV = import.meta.env.VITE_ENV;

export const CRYPTO_SECRET_PASSPHRASE = 'iglu123!';

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
